export default function splitSubgoalWeights(
  total: number,
  count: number,
): number[] {
  if (count <= 0) return [];
  const safeTotal = Math.max(0, total);
  const base = Math.floor(safeTotal / count);
  const remainder = safeTotal - base * count;
  return Array.from({ length: count }, (_, idx) =>
    idx < remainder ? base + 1 : base,
  );
}
